"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series, isZeroAsNull) {
    return series[0].data.map(function (value, index) {
        return series.reduce(function (total, obj) {
            return total + obj.data[index];
        }, 0);
    }).map(function (value) {
        return isZeroAsNull && value === 0 ? null : value;
    });
};
//# sourceMappingURL=getStackedData.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getStackedData.js
 ** module id = 92
 ** module chunks = 0 1
 **/